export enum BillingType {
  FREE_PUBLIC = 'FREE_PUBLIC',
  FREE_ACCESS_CONTROLLED = 'FREE_ACCESS_CONTROLLED',
  BILLED_CHARGING = 'BILLED_CHARGING',
  BILLED_PLUGGED = 'BILLED_PLUGGED',
  BILLED_BY_KWT = 'BILLED_BY_KWT',
  BILLED_ESTIMATED_KWT = 'BILLED_ESTIMATED_KWT',
  UNKNOWN = 'UNKNOWN',
}
